import { useNavigate, useParams } from "react-router-dom"
import { useEffect } from "react"
import GameLayout from "@/modules/flashcards/features/game/game-layout"
import { useUpdateUserLives } from "@/modules/user/queries/use-discount-user-live"
import { toast } from "sonner"
import useGetFlashcard from "@/modules/flashcards/queries/use-get-flashcard"

const FlashcardGamePage = () => {
  const { flashcardId } = useParams()
  const navigate = useNavigate()
  const { mutateAsync, isPending, error } = useUpdateUserLives()
  const { data, isPending: isLoading, error: isFlashcardError } = useGetFlashcard(flashcardId ?? "")

  const discountLive = async () => {
    try {
      await mutateAsync()
    } catch {
      toast.error("Algo salió mal", {
        description: error?.message,
      })
      navigate("/flashcards")
    }
  }

  useEffect(() => {
    discountLive()
  }, [])

  if (isFlashcardError) {
    navigate("/flashcards")
    return
  }

  return (
    <div className="h-full w-full bg-white">
      {isPending || isLoading ? (
        <p className="flex size-full items-center justify-center">Cargando...</p>
      ) : (
        <GameLayout gameData={{ flashcards: data.flashcards, name: data.name }} />
      )}
    </div>
  )
}

export default FlashcardGamePage
